import React, { Component } from 'react';
import { doReviewsubmit, popModal, UpdateState, getState, getSession, AlertMessage, AlertMessageOut, clearSession } from "./function";
import ReactPaginate from 'react-paginate';
import { limit_per_page, name, ApiEndpoint, platform, documentAllowedRepo, documentAllowed } from "../Constant";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import FileUnsupported from "../Assets/FileUnsupported.png";
import Button from "../Components/button";
import Form from "../Components/form";
import { Input, Textarea, Select, File } from "../Components/input";
import * as axios from 'axios';
import $ from "jquery";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class DataTable extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        userID : '',
        title: '',
        desc: '',
        file: '',
        page: 1,
        total_page: 1,
        total_result: 0,
        offset: '-1',
        offset_set: 0,
        limit: limit_per_page,
        page_target: '0',
        search_query: '',
        data: [],
        message: '',
        loading: '',
        retry_times: 0,
      }

      this.clearPagingData = this.clearPagingData.bind(this);
      this.updatePageTarget = this.updatePageTarget.bind(this);
      this.updatePageRegionTarget = this.updatePageRegionTarget.bind(this);
      }
  
      componentDidMount(){
       var that = this;
       this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));

      
      }
  
      componentDidUpdate(prevProps) {
       //this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      }
     
      AlertNoTableData = (len) => {
        return <tr><td colspan={len}><div className='p15 center block'>No Table Data - No Result found!</div></td></tr>;
      }

      showUploadModal = () => {
        $('.upload-modal').addClass('show-modal');
      }
     
     clearPagingData = () => {
        UpdateState(this, 'page', 1);
        UpdateState(this, 'total_page', 1);
        UpdateState(this, 'total_result', 0);
        UpdateState(this, 'offset', '-1');
        UpdateState(this, 'offset_set', 0);
     }

     updatePageTarget(target){
       UpdateState(this, 'page_target', target);
     }

     updatePageRegionTarget(target){
       UpdateState(this, 'specific_region', target);
     }

      handlePageClick = (data) => {

        let selected = data.selected;
        let offset = Math.ceil((selected) * limit_per_page);
         UpdateState(this, 'offset', offset == 0 ? '-1' : offset);
         UpdateState(this, 'offset_set', offset);
         UpdateState(this, 'page', (selected + 1));
         let $search_query = getState(this, 'search_query'); 
        
         if($search_query != ""){
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), $search_query);
        }
        else{
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
        }
        };
      
      loadDataFromServer = async (cmd, offset, limit, search_query = "") => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: this.props.cmd,
            user_id: getSession('userID'),
            limit: getState(this, 'limit'),
            offset: getState(this, 'offset'),
            page: getState(this, 'page'),
            search_query: search_query?.length ? search_query : '',
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');

            if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer(cmd, offset, limit);
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
          //alert(JSON.stringify(response.data.data));
          UpdateState(this, 'data', response.data.data.length > 0 ? response.data.data : []);
          UpdateState(this, 'total_page', response.data.total_page);
          UpdateState(this, 'total_result', response.data.total_result);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');
            
            $(function() {

            $('.disabled').each(function() {
            //$(this).prop('title', "Disabled and Unavailable for Click Option");
            });
            
            });

          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
           UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
             UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            this.loadDataFromServer(cmd, offset, limit);
        });
      }
  


  render() {
    return ( 
        <>
    <div className="responsive-tables">

  {getState(this, 'loading') == '1' ?
   (<div className="table-loader">
  <div className="overlay">
    <div className="overlay__inner">
        <div className="overlay__content"><span className="spinner"></span></div>
    </div>
</div>
</div>) : ''}

<div className="right" style={{marginBottom: '8px'}}>
<button onClick={() => this.showUploadModal() } className="upload-btn-repo"><i className="fa fa-upload"></i> Upload File</button>
</div>

<div className="modal-content-overlay upload-modal">
 
     <div className="modal-wrap-small">
        <div className="modal-small upload-modal">
    <div className="modal-head"><span className="small-modal-data-title">Upload File to Repository</span> 
    <span className="close close-modal"><i className="fa fa-times"></i></span></div>
    <div className="modal-body">
    <div className="small-modal-data-body">

      <div className="card-lt-wraps">
    <div className="card-lts">
      
    <div className="card-form-lts">
        <div className="title-lt hidden">Upload a File</div>

    <Form route="submit">
     
     {AlertMessageOut(this)}

      <Input 
      wrapperClass="form-group-lt"
      inputType="text"
      inputClass="input-lt"
      inputState="title"
      inputPlaceholder="File Title"
      inputMaxLength="125"
      self={this} />

      <Textarea 
      wrapperClass="form-group-lt"
      inputClass="input-lt"
      inputState="desc"
      inputPlaceholder="File Description"
      inputRows="5"
      inputCols="50"
      inputMaxLength="350"
      self={this} />

      <File
      wrapperClass="form-group-lt"
      inputClass="input-lt"
      inputState="file"
      inputPlaceholder="Upload File"
      inputAccept={documentAllowedRepo}
      self={this} />


      <Button 
       wrapperClass="form-group-lt center" 
       buttonClass="button-lt" 
       buttonText="UPLOAD"
       buttonAction="upload_repo_file"
       self={this} />
       
       </Form>
         
  
    </div>
   
    </div>
    </div>

    </div>
    </div>

    <div className="modal-foot"><span className="close close-modal">
        <i className="fa fa-times"></i> Close</span></div>
    </div>
        </div>

    </div>

    {AlertMessageOut(this)}

 
    <div className="card-lt-wraps">
    <div className="card-lts">
    <div className="commit-tease">
        
    <Form route="submit">
   
      <div className="search-repo-wrap">
          <input type="text" className="search-repo-input" placeholder="Search Repository" 
          onChange={(input) => UpdateState(this, 'search_query', input.target.value)} /> 
   <button onClick={() => this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), getState(this, 'search_query'))} 
   className="search-repo-button"> <i className="fa fa-search"></i> Search</button>
          </div>
      </Form>
    </div>
</div>
</div>


<div className="responsive-table">
    <table>
        
 <thead><tr>
 <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </thead>

 <tbody>
 {getState(this, 'data')?.length == 0 ? this.AlertNoTableData(this.props.th.length + 1) : ''}
 {getState(this, 'data')?.map((td, i) => {
        let $fileModal = "";

    $fileModal += "<div class='p15' style='background: #e2e2e2; position: relative; margin-top: 20px;'><div class='card-lt-wraps'><div class='card-lt'><div id='response-message' class='hide'> </div>";
    $fileModal += "<div class='commit-tease-lefts' style='text-align: left;'><i class='fa fa-file' style='font-size: 80px; padding: 10px; border: 1px solid #c8e1ff;margin-bottom: 10px;'></i></div>";
    $fileModal += "<div class='commit-tease-left'>Title: <b style='font-weight: 550;'>"+td['title']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'>Description: <b style='font-weight: 550;'>"+td['desc']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'>Name: <b style='font-weight: 550;'>"+td['file']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'>Size: <b style='font-weight: 550;'>"+td['file_size']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'>File ID: <b style='font-weight: 550;'>"+td['fileID']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'>Uploaded By: <b style='font-weight: 550;'>"+td['userID']+"</b></div>";
    $fileModal += "<div class='commit-tease-left'><button data-file-uri='"+td['file_url']+"' class='download-file chip primaryX'><i class='fa fa-download'></i> Download Now</button></div>";
    $fileModal += "</div></div></div>";
   return(
     <tr key={i}>
     <td key={i}> {i+1} </td>
     <td className="absorbing-column min-width-td"><div className="repo-file-title"
     onClick={() => popModal('large', {title: td['fileID'], body: $fileModal})}>
         <i className="fa fa-file"></i> {td['title']}</div></td>
     <td>{td['fileID']}</td>

     <td>
     <div className="chip-flex">
         <button className={"chip primaryX"}
          title="File Type"> {td['file_ext'].toUpperCase()} </button>
         </div>
         </td>
     
         <td>
     <div className="chip-flex nowrap">
     {td['added']}
         {/*<button className={"btn-activeable chip primaryX pop-feedback-modal "}
         //onClick={() => popModal('large', {title: td['scriptID'], body: $feedbackModal})}
   data-modalData={td['scriptID']} title="Feedback"> F </button>*/}
         </div>
         </td>

        
         
    </tr>
    );
     })}

     </tbody>

    <tfoot><tr>
    <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i}>{th}</th>
     })}
 </tr>
 </tfoot>

</table>
</div>

<div className="card-lt">  

<div>Page: {getState(this, 'page')} of {getState(this, 'total_page')} ⟺ ☆ Result: {parseInt(getState(this, 'offset_set')) + parseInt(1)} - {Math.ceil(getState(this, 'page') * limit_per_page) >= getState(this, 'total_result') ? getState(this, 'total_result') : Math.ceil(getState(this, 'page') * limit_per_page)} of {getState(this, 'total_result')}</div>

<ReactPaginate
          previousLabel={'« Prev'}
          nextLabel={'Next »'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={getState(this, 'total_page')}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
 </div>
</div>
</>
);
}
}

export default DataTable;